import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../../common/Header";
import $ from "jquery";
import useAuth from "../../../hooks/useAuth";
import Toastify from "../../common/Toastify";
import { GETREQUEST, POSTREQUEST } from "../../helpers/ServiceRequest";

function EditCrateSupplier() {
  const [csName, setCSName] = useState("");
  const [current, setCurrent] = useState(1);
  const [csError, setCSError] = useState(false);
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

  useEffect(() => {
    var headerHeight = $("header").outerHeight();
    var mainHeight = $(window).height() - headerHeight;
    $("main").height(mainHeight);
    $("main").css("margin-top", headerHeight + "px");
  });

  let navigate = useNavigate();
  const { id } = useParams();
  const { user } = useAuth();
  useEffect(() => {
    const fetchData = async () => {
      let URL = process.env.REACT_APP_API_URL + "/get-crate-suppliers/" + id;
      let response = await GETREQUEST(URL, user.jwtToken);
      if (response?.data) {
        setCSName(response.data.CrateSupplier);
        setCurrent(String(response.data.Current));
      }
    }
    fetchData();
  }, []);

  const editCrateSupplier = async (e) => {
    e.preventDefault();

    // Validate input fields
    if (csName === "") {
      setCSError(true);
      return false;
    }
    let URL = process.env.REACT_APP_API_URL + "/update-crate-suppliers";

    let payload = { CrateSupplier: csName, Current: parseInt(current), CSID: id };
    let response = await POSTREQUEST(URL, payload, user.jwtToken);
    if (response?.data) {
      if (response.data.success) {
        setMessage(response.data.message);
        setMessageType('success');
        setTimeout(() => {
          navigate("/crate-suppliers");
        }, 2000);
      } else {
        setMessage(response.data.message);
        setMessageType('error');
      }
    }
    else {
      setMessage(response?.error?.message || 'Failed to update crate supplier !!');
      setMessageType('error');
    }
  };

  return (
    <React.Fragment>
      <Header />
      {message && <Toastify message={message} type={messageType} />}
      <main className="bg-lite-grey overflow-auto">
        <section className="px-4 pt-3 pb-4">
          <div className="table-elements">
            <nav style={{ ariaLabel: "breadcrumb" }}>
              <ol className="breadcrumb">
                <li className="breadcrumb-item fs-15">
                  <Link
                    to="/crate-suppliers"
                    className="text-decoration-none text-primary"
                  >
                    Crate Suppliers
                  </Link>
                </li>
                <li
                  className="breadcrumb-item fs-15 active"
                  aria-current="page"
                >
                  Edit Crate Supplier
                </li>
              </ol>
            </nav>
          </div>
          <div className="row justify-content-center">
            <div className="width-xxl-35 width-xl-44 width-lg-60 width-md-80">
              <div className="card p-4">
                <div className="card-header bg-white border-bottom-0">
                  <h1 className="title-semibold fs-24 mb-1">
                    Edit Crate Supplier
                  </h1>
                  {/* <p className="text-lite fs-15 mb-0">
                    Please enter details to add new Crate Supplier
                  </p> */}
                </div>
                <form onSubmit={editCrateSupplier}>
                  <div className="card-body">
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Crate Supplier Name
                      </label>
                      <div className="col">
                        <input
                          type="text"
                          className={
                            "form-control input-md " +
                            (csError ? " is-invalid" : "")
                          }
                          placeholder="Enter Crate Supplier Name"
                          onChange={(e) => {
                            setCSError(false);
                            setCSName(e.target.value);
                          }}
                          value={csName}
                        />
                      </div>
                    </div>
                    <div className="cmb-15 row g-3">
                      <label className="width-sm-35 d-flex align-items-center fs-15 text-dark text-nowrap">
                        Status
                      </label>
                      <div className="col">
                        <select
                          className={
                            "form-select input-md "
                          }
                          aria-label="Default select example"
                          onChange={(e) => {
                            setCurrent(e.target.value);
                          }}
                          value={current}
                        >
                          <option value={1}>Active</option>
                          <option value={0}>Inactive</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  <div className="card-footer bg-white d-flex p-3 border-top-0">
                    <div className="d-grid w-100">
                      <button
                        type="submit"
                        className="btn btn-secondary btn-md text-white d-flex align-items-center justify-content-center px-4 fw-medium rounded-3 mx-1"
                      >
                        Edit Crate Supplier
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      </main>
    </React.Fragment>
  );
}
export default EditCrateSupplier;
